import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const CAPTURE_WIDTH = 794;
const CANVAS_SCALE = 1.25;
const JPEG_QUALITY = 0.82;
const PDF_MARGIN_MM = 8;

const prepareCaptureClone = (sourceElement) => {
    const container = document.createElement('div');
    container.setAttribute('aria-hidden', 'true');
    container.style.cssText = `
        position: fixed;
        left: -10000px;
        top: 0;
        width: ${CAPTURE_WIDTH}px;
        background: #ffffff;
        pointer-events: none;
        z-index: -1;
    `;

    const clone = sourceElement.cloneNode(true);
    clone.style.cssText = `
        width: ${CAPTURE_WIDTH}px;
        max-width: ${CAPTURE_WIDTH}px;
        min-width: ${CAPTURE_WIDTH}px;
        height: auto;
        max-height: none;
        overflow: visible;
        display: block;
        background: #ffffff;
    `;

    clone.querySelectorAll('.row').forEach((row) => {
        row.style.display = 'flex';
        row.style.flexWrap = 'nowrap';
        row.style.margin = '0';
    });

    clone.querySelectorAll('[class*="col-"]').forEach((col) => {
        const classes = col.className;
        if (classes.includes('col-lg-5')) {
            col.style.flex = '0 0 41.666667%';
            col.style.maxWidth = '41.666667%';
        } else if (classes.includes('col-lg-2')) {
            col.style.flex = '0 0 16.666667%';
            col.style.maxWidth = '16.666667%';
        } else if (classes.includes('col-sm-4')) {
            col.style.flex = '0 0 33.333333%';
            col.style.maxWidth = '33.333333%';
        } else if (classes.includes('col-sm-6')) {
            col.style.flex = '0 0 50%';
            col.style.maxWidth = '50%';
        }
        col.style.width = 'auto';
    });

    clone.querySelectorAll('*').forEach((el) => {
        el.style.overflow = 'visible';
        el.style.maxHeight = 'none';
    });

    clone.querySelectorAll('.table-responsive').forEach((el) => {
        el.style.overflow = 'visible';
    });

    container.appendChild(clone);
    document.body.appendChild(container);

    return { container, clone };
};

export const generateInvoicePdf = async (sourceElement) => {
    const { container, clone } = prepareCaptureClone(sourceElement);

    try {
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

        const canvas = await html2canvas(clone, {
            scale: CANVAS_SCALE,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff',
            allowTaint: true,
            width: CAPTURE_WIDTH,
            height: clone.scrollHeight,
            windowWidth: CAPTURE_WIDTH,
            windowHeight: clone.scrollHeight,
        });

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const contentWidth = pageWidth - PDF_MARGIN_MM * 2;
        const contentHeight = pageHeight - PDF_MARGIN_MM * 2;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;
        const imgData = canvas.toDataURL('image/jpeg', JPEG_QUALITY);

        let heightLeft = imgHeight;
        let y = PDF_MARGIN_MM;

        pdf.addImage(imgData, 'JPEG', PDF_MARGIN_MM, y, contentWidth, imgHeight);
        heightLeft -= contentHeight;

        while (heightLeft > 0) {
            pdf.addPage();
            y = PDF_MARGIN_MM - (imgHeight - heightLeft);
            pdf.addImage(imgData, 'JPEG', PDF_MARGIN_MM, y, contentWidth, imgHeight);
            heightLeft -= contentHeight;
        }

        return pdf.output('datauristring');
    } finally {
        document.body.removeChild(container);
    }
};
